import { dtoToRgObject } from '../../dto-to-rg-object.js';
import { RG_TYPE } from '../../../../types/rg-type.js';
import { isPolygonClosed } from '../../../../math/is-polygon-closed.js';

/** list of types with polygon data affected by changes to js-clipper methods. Should be the same list as `InterfacesWithPolygonData` */
const TypesWithClipperPoly = [RG_TYPE.Floor, RG_TYPE.TechnicalSpace];
/** this method upgrades polygon data generated from js-clipper which wasn't creating closed polys before */
const dtoTypeWithClipperPoly = (dto, versions) => {
    if (getMajor(versions.core) >= 7 ||
        !dto.data ||
        !dto.data.polygon ||
        isPolygonClosed(dto.data.polygon))
        return dtoToRgObject(dto, { versions, partials: {}, top: false });
    const polygon = dto.data.polygon.slice();
    polygon.push(polygon[0]);
    const data = {
        ...dto.data,
        polygon
    };
    return dtoToRgObject(dto, { versions, partials: { data }, top: false });
};
const getMajor = (value) => parseInt(value.split('.')[0].replace('^', '').replace('~', ''));

export { TypesWithClipperPoly, dtoTypeWithClipperPoly };
//# sourceMappingURL=dto-to-type-with-clipper-poly.js.map
